import script from "./ChoiceCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./ChoiceCard.vue?vue&type=script&lang=ts&setup=true"

import "./ChoiceCard.vue?vue&type=style&index=0&id=9e4344b8&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9e4344b8"]])

export default __exports__